module.exports = __webpack_public_path__ + "static/media/logo_mbbank.4e8d23d4.svg";